
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AuthButtons from './AuthButtons';
import Navigation from './Navigation';
import { useIsMobile } from '@/hooks/use-mobile';
import MobileMenuToggle from './MobileMenuToggle';
import { NavItem } from '@/types/layout';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isMobile = useIsMobile();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const navItems: NavItem[] = [
    { name: 'Features', path: '/features' },
    { name: 'Bing Ads', path: '/bing-ads' },
    { name: 'Storm Response', path: '/storm-response' },
    { name: 'Keyword Optimisation', path: '/keyword-optimisation' },
    {
      name: 'Solutions',
      path: '/solutions',
      dropdown: [
        { name: 'Agency', path: '/agency' },
        { name: 'Microsoft Advertising (Bing)', path: '/bing-ads' },
        { name: 'Google Ads Freelancer', path: '/freelancer' },
        { name: 'Solopreneur', path: '/solopreneur' },
        { name: 'Beginner', path: '/beginner' },
        { name: 'CEO/Business Owner', path: '/business-owners' },
        { name: 'SaaS Marketers', path: '/saas' },
        { name: 'Startups', path: '/startup' },
        { name: 'International Companies', path: '/international' },
      ],
    },
    { name: 'Compare', path: '/compare' },
    { name: 'MCP', path: '/mcp' },
    { name: 'Pricing', path: '/pricing' },
    { name: 'How It Works', path: '/how-it-works' },
    { name: 'About', path: '/about' },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white dark:bg-gray-900 shadow-md py-2'
          : 'bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm py-4'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Link to="/" className="text-2xl font-bold text-primary mr-8">
              Upfixe
            </Link>

            <Navigation navItems={navItems} />
          </div>

          <div className="flex items-center">
            <AuthButtons />

            <MobileMenuToggle
              isOpen={isMobileMenuOpen}
              onClick={toggleMobileMenu}
            />
          </div>
        </div>

        {isMobileMenuOpen && isMobile && (
          <Navigation
            navItems={navItems}
            isMobile={true}
            onItemClick={() => setIsMobileMenuOpen(false)}
          />
        )}
      </div>
    </header>
  );
};

export default Header;
